<template>
  <v-app>
    <v-container
      fluid
    >
      <v-snackbar
        v-model="showing"
        :timeout="timeout"
        :color="type"
        transition
        left
        dense
        class="shadow-none p-0 border-0"
      >
        <v-alert
            class="m-0"
            :type="type"
        >
          {{message}}
        </v-alert>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "toast.vue",

  data(){
    return {
      showing : false
    }
  },
  watch:{
    showing(n , o){
      this.show(n)
    },
    isShow(n, o){
      this.showing = n
    }
  },

  computed :{
    ...mapGetters('toast', ['isShow' , 'message', 'timeout', 'type'])
  },
  methods:{
    ...mapActions('toast', ['show'])
  }
}
</script>

<style>
 .v-snack__content{
   padding: 0;
 }
</style>